import React, { useEffect, useMemo } from 'react';
import { useFormWatch } from '../../../../helpers/formManager';
import {
  fieldNames,
  fieldPathBuilders,
} from '../../shared/configs/acceptanceForm';
import { createReactiveContext } from '../../../../helpers/reactiveContext';
import { useDeskNamesData } from '../../services/queries/deskNames';

const { Provider, useMethods, useSelector } = createReactiveContext();

const emptyArr = [];

const initialState = {
  availableNames: [],
  hasNames: false,
};

export const useCanAddDesk = () =>
  useSelector((state) => state.availableNames.length > 0);

export const useAvailableDeskNames = () =>
  useSelector((state) => state.availableNames);

export const useHasDeskNames = () => useSelector((state) => state.hasNames);

export const DesksDataTracker = ({ children }) => {
  const { data } = useDeskNamesData();

  const names = !data || data === 'Error' ? emptyArr : data;

  return (
    <Provider initialState={initialState}>
      <Container names={names}>{children}</Container>
    </Provider>
  );
};

function Container({ names = emptyArr, children }) {
  const desks = useFormWatch({
    name: fieldNames.main.desks,
    exact: true,
    defaultValue: [],
  });

  const deskCount = desks.length;
  const watchedFieldNames = useMemo(
    () => createWatchedFieldNames(deskCount),
    [deskCount]
  );

  const values = useFormWatch({ name: watchedFieldNames });
  const selectedNames = useMemo(
    () => new Set(values.filter((v) => Boolean(v?.label)).map((v) => v.label)),
    [values]
  );

  const { setValue } = useMethods();

  // Задаем доступные имена столов и возможность добавления нового стола
  useEffect(() => {
    const availableNames = names.filter(
      (item) => !selectedNames.has(item.name)
    );
    setValue('availableNames', availableNames);
  }, [names, selectedNames, setValue]);

  // Задаем наличие имен столов
  const hasNames = names.length > 0;
  useEffect(() => {
    setValue('hasNames', hasNames);
  }, [hasNames, setValue]);

  return children;
}

function createWatchedFieldNames(count) {
  const names = [];
  for (let i = 0; i < count; i++) {
    names.push(fieldPathBuilders.desk.name(i));
  }
  return names;
}
